// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__MOSqJ","buttons":"PendingPaymentAlert_buttons__2aMKB"};